export default __webpack_public_path__ + "static/Wantedly_org-12a9cb232267c897bbafb71d46a58508.png";